export const contact = {
  phoneDisplay: '829-330-1179',
  phoneLink: '18293301179',
  address: 'Calle Padre Billini, Bonao 42000, Monseñor Nouel, República Dominicana.',
  facebook: 'Muchacho E’ Mandao / @mandaobonao',
  facebookUrl: 'https://www.facebook.com/mandaobonao',
  whatsappMessage: 'Hola Muchacho E’ Mandao, necesito hacer un mandao.'
};

export const schedule = {
  weekdays: '8:00 a. m. – 10:30 p. m.',
  weekends: '9:00 a. m. – 11:00 p. m.'
};

export const logoUrl = 'https://media-manager-c.questera.ai/greta-media/786069decac80ebfda9758781ecad48f576fd486e338363dff55357567d6916b51c713fb933d539c7b707900e265a4cf/images/aW1hZ2UvcG5n/c81886661de680ae34275ae28d60d03b.png';

export const coverImageUrl = 'https://media-manager-c.questera.ai/greta-media/786069decac80ebfda9758781ecad48f576fd486e338363dff55357567d6916b51c713fb933d539c7b707900e265a4cf/images/aW1hZ2UvcG5n/6950d90852f1f46f536fc2ffa28c442f.png';

export const whatsappUrl = (message = contact.whatsappMessage) =>
  `https://wa.me/${contact.phoneLink}?text=${encodeURIComponent(message)}`;